// Bloom Foundry brand assets and shared constants.
export const LOGOS = {
  bloomFoundry:
    "https://customer-assets.emergentagent.com/job_bloom-gallery-14/artifacts/7bntz2k7_FOUNDRY_001.png",
  heritageDahlias:
    "https://customer-assets.emergentagent.com/job_bloom-gallery-14/artifacts/a435h7q9_file_0000000091ec71faa145461523f94037.png",
  etchery:
    "https://customer-assets.emergentagent.com/job_c029e9ca-53b3-4fa9-82ae-b9381d8510da/artifacts/ez67q03s_Etcherylogo.png",
};

export const PHOTOS = {
  vasesBright: "https://images.unsplash.com/photo-1558879860-45f24b366ea1?w=1400&q=85",
  vasesCeramic: "https://images.pexels.com/photos/32490730/pexels-photo-32490730.jpeg?auto=compress&cs=tinysrgb&w=1400",
  dahlia1: "https://images.unsplash.com/photo-1568613406732-341ae92e8ff1?w=1400&q=85",
  dahlia2: "https://images.unsplash.com/photo-1627455608762-4010cef97df4?w=1400&q=85",
  farmRows: "https://images.unsplash.com/photo-1651592278793-888fc1be49a5?w=1600&q=85",
  farmPlanting: "https://images.unsplash.com/photo-1651592278720-fd9479be2a9b?w=1600&q=85",
  printer1: "https://images.pexels.com/photos/24859620/pexels-photo-24859620.jpeg?auto=compress&cs=tinysrgb&w=1400",
  printer2: "https://images.pexels.com/photos/12698667/pexels-photo-12698667.jpeg?auto=compress&cs=tinysrgb&w=1400",
  balloonDog: "https://images.pexels.com/photos/33220285/pexels-photo-33220285.jpeg?auto=compress&cs=tinysrgb&w=1400",
  workshop: "https://images.pexels.com/photos/4348298/pexels-photo-4348298.jpeg?auto=compress&cs=tinysrgb&w=1400",
  workshopDetails: "https://images.pexels.com/photos/4219156/pexels-photo-4219156.jpeg?auto=compress&cs=tinysrgb&w=1400",
  bloomBox: "https://images.pexels.com/photos/30828535/pexels-photo-30828535.jpeg?auto=compress&cs=tinysrgb&w=1400",
  bloomBox2: "https://images.pexels.com/photos/426905/pexels-photo-426905.jpeg?auto=compress&cs=tinysrgb&w=1400",
  reference: "https://customer-assets.emergentagent.com/job_c029e9ca-53b3-4fa9-82ae-b9381d8510da/artifacts/3a9esk7g_file_000000007f287207a5f810d6fa8f8667.png",
};

/* The actual Bloom Foundry × Etchery product photography. */
export const PRODUCTS = {
  gardenStake: "https://customer-assets.emergentagent.com/job_bloom-gallery-14/artifacts/4cwuzenf_CA046CFC-7EB7-4F2B-981C-C9E1070DC436.png",
  pompomRings: "https://customer-assets.emergentagent.com/job_bloom-gallery-14/artifacts/r01w8ft2_B42E4045-977A-403F-9B00-754C5D037C21.jpg",
  swirlVase: "https://customer-assets.emergentagent.com/job_bloom-gallery-14/artifacts/pawy3ngu_1634CC34-A76B-4006-AFC0-2B2F7271D6DE.jpg",
  sweryTags: "https://customer-assets.emergentagent.com/job_bloom-gallery-14/artifacts/l531xgyc_93F8B8B3-69C1-4E69-8C21-50E3D74697E9.jpg",
  balloonDogReal: "https://customer-assets.emergentagent.com/job_bloom-gallery-14/artifacts/mhjeahoy_1480320C-ED60-46DB-A8E2-9205EB7C0ABA.jpg",
};

export const NAV_LINKS = [
  { label: "HOME", to: "/" },
  { label: "FOUNDRY WORKSHOP", to: "/workshop" },
  { label: "SUPPLY ROOM", to: "/supply-room" },
  { label: "GALLERY", to: "/gallery" },
  { label: "BLOOM ID", to: "/bloom-id" },
  { label: "HERITAGE BLOOM CLUB", to: "/bloom-club" },
  { label: "CONTACT + ABOUT", to: "/contact" },
];
